import {ExpandedGroupIds} from '@hconnect/common/hooks/useExpandGroups'
import {ManualKpiToUpdate, ProcessStage} from '@hconnect/common/types'
import {formatNumber} from '@hconnect/common/utils'
import {Column} from '@hconnect/uikit/src/lib2'
import {Typography} from '@mui/material'
import {TFunction} from 'i18next'
import {isUndefined} from 'lodash'
import {FC, useMemo} from 'react'
import {useTranslation} from 'react-i18next'

import {KPIS_WIDGET_NAMESPACE} from '../consts'

import {ManualKpiWrapper} from './ManualKpiWrapper'

type ManualKpiPreviewProps = {
  manualKpiList: ManualKpiToUpdate[]
  openProcessStages: string[]
  setOpenProcessStages: (id: ExpandedGroupIds) => void
  processStages: ProcessStage[]
  isProcessStagesLoading: boolean
}

export const ManualKpiPreview: FC<ManualKpiPreviewProps> = ({
  manualKpiList,
  setOpenProcessStages,
  openProcessStages,
  processStages,
  isProcessStagesLoading
}) => {
  const {
    t,
    i18n: {language}
  } = useTranslation(KPIS_WIDGET_NAMESPACE)

  const columns = useMemo<Column<ManualKpiToUpdate>[]>(
    () => generateColumns(t, language),
    [t, language]
  )

  return (
    <ManualKpiWrapper
      setOpenProcessStages={setOpenProcessStages}
      openProcessStages={openProcessStages}
      isProcessStagesLoading={isProcessStagesLoading}
      processStages={processStages}
      manualKpiList={manualKpiList}
      columns={columns}
    />
  )
}

const COLUMN_SX = {
  px: {xs: 0.75, sm: 0.75}
}

const generateColumns = (t: TFunction, language: string): Column<ManualKpiToUpdate>[] => [
  {
    key: 'name',
    label: t('manualKpi.label.kpi'),
    columnSx: COLUMN_SX,
    customTemplate: ({name}) => <Typography variant="h5">{name}</Typography>
  },
  {
    key: 'planned',
    label: t('manualKpi.label.planned'),
    width: 105,
    columnSx: COLUMN_SX,
    customTemplate: ({plannedValue, unit}) =>
      isUndefined(plannedValue) ? (
        <></>
      ) : (
        <Typography variant="body1">
          {formatNumber(plannedValue, language)} {unit}
        </Typography>
      )
  },
  {
    key: 'actual',
    label: t('manualKpi.label.actual'),
    width: 105,
    columnSx: COLUMN_SX,
    customTemplate: ({actualValue, unit}) =>
      isUndefined(actualValue) ? (
        <></>
      ) : (
        <Typography variant="body1">
          {formatNumber(actualValue, language)} {unit}
        </Typography>
      )
  }
]
